const SUBJECTS_KEY = 'studysnap_subjects';
const TASKS_KEY = 'studysnap_tasks';
const THEME_KEY = 'studysnap_theme';
const SETTINGS_KEY = 'studysnap_settings';

// Default subjects with colors
const DEFAULT_SUBJECTS = [
  { id: 'math', name: 'Mathematics', color: '#3B82F6' },
  { id: 'science', name: 'Science', color: '#10B981' },
  { id: 'history', name: 'History', color: '#F59E0B' },
  { id: 'language', name: 'Language Arts', color: '#EF4444' },
  { id: 'other', name: 'Other', color: '#8B5CF6' }
];

export const getSubjects = () => {
  const data = localStorage.getItem(SUBJECTS_KEY);
  const subjects = data ? JSON.parse(data) : DEFAULT_SUBJECTS;

  // Ensure all subjects have color property
  return subjects.map(subject => ({
    ...subject,
    color: subject.color || '#8B5CF6'
  }));
};

export const saveSubjects = (subjects) => {
  localStorage.setItem(SUBJECTS_KEY, JSON.stringify(subjects));
};

export const getTasks = () => {
  const data = localStorage.getItem(TASKS_KEY);
  const tasks = data ? JSON.parse(data) : [];

  // Migrate existing tasks to include priority and other new fields
  return tasks.map(task => ({
    priority: 'medium', // Default priority
    time: '',
    remindMe: false,
    subjectColor: null, // Will be set dynamically
    ...task
  }));
};

export const saveTasks = (tasks) => {
  localStorage.setItem(TASKS_KEY, JSON.stringify(tasks));
};

// Theme management
export const getTheme = () => {
  const data = localStorage.getItem(THEME_KEY);
  return data || 'light';
};

export const saveTheme = (theme) => {
  localStorage.setItem(THEME_KEY, theme);
};

// Settings management
export const getSettings = () => {
  const data = localStorage.getItem(SETTINGS_KEY);
  return data ? JSON.parse(data) : {
    focusMode: false,
    showProgress: true,
    enableNotifications: false
  };
};

export const saveSettings = (settings) => {
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
};

// Streak management
export const getStreakData = () => {
  const data = localStorage.getItem('streakData');
  if (!data) {
    return {
      currentStreak: 0,
      lastCompletedDate: null,
      longestStreak: 0
    };
  }
  return JSON.parse(data);
};

export const updateStreakData = (completedToday) => {
  const today = new Date().toDateString();
  const streakData = getStreakData();

  if (completedToday) {
    if (streakData.lastCompletedDate === today) {
      // Already counted today
      return streakData;
    }

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayString = yesterday.toDateString();

    if (streakData.lastCompletedDate === yesterdayString || streakData.lastCompletedDate === null) {
      // Continuing streak or starting new one
      streakData.currentStreak += 1;
      streakData.longestStreak = Math.max(streakData.longestStreak, streakData.currentStreak);
    } else {
      // Streak broken, start new one
      streakData.currentStreak = 1;
    }

    streakData.lastCompletedDate = today;
  } else {
    // Check if streak should be broken (missed a day)
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayString = yesterday.toDateString();

    if (streakData.lastCompletedDate !== yesterdayString && streakData.lastCompletedDate !== today) {
      streakData.currentStreak = 0;
    }
  }

  localStorage.setItem('streakData', JSON.stringify(streakData));
  return streakData;
};
